import React from "react";
import { Button, useTheme } from "@mui/material";
import { FaPencil } from "react-icons/fa6";

const EditButton = ({ label = "Alterar", onClick, disabled = false }) => {

    const theme = useTheme();
    return (
        <Button
            variant="outlined"
            startIcon={<FaPencil size="14px" />}
            color="primary"
            size="small"
            disabled={disabled}
            type="button"
            onClick={onClick}
        >
            {label}
        </Button>
    );
}

export default EditButton;
